import React from 'react'
import classNames from 'classnames'

import Modal from '../../common/Modal'
import { ReactComponent as GolferIcon } from '../../../assets/images/common/icons/golfer-half-icon.svg'
import { ReactComponent as ExportIcon } from '../../../assets/images/common/communityLeaderboard/Export.svg'


import classes from './ExportMembersModal.module.scss'
import PropTypes from 'prop-types'

const ExportMembersModal = ({ exportUrl, clearExportResult }) => (
  <Modal
    isOpen={!!exportUrl}
    onClose={clearExportResult}
    className={classes.modal}
  >
    <main className={classNames(classes.content, 'd-flex align-items-center flex-column')}>
      <GolferIcon className={classes.icon} />
      <h4 className='font-weight-bold'>Members Exported</h4>
      <p className='text-center'>The results have been exported successfully,<br/> download the file to view.</p>

      <a className='btn btn-primary text-white px-4 font-weight-bold' href={exportUrl}>Download CSV <ExportIcon className={classes.exportIcon} /></a>
    </main>
  </Modal>
)

ExportMembersModal.propTypes = {
  exportUrl: PropTypes.string.isRequired,
  exportError: PropTypes.string,
  clearExportResult: PropTypes.func.isRequired,
}

export default ExportMembersModal
